import { render, staticRenderFns } from "./AllTasks.vue?vue&type=template&id=2e051d56&scoped=true"
import script from "./AllTasks.vue?vue&type=script&lang=js"
export * from "./AllTasks.vue?vue&type=script&lang=js"
import style0 from "./AllTasks.vue?vue&type=style&index=0&id=2e051d56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e051d56",
  null
  
)

export default component.exports